import * as React from 'react'

import { Portal, PortalProps } from '../../../components/Portal'
import { QuoteContext } from '../QuoteContext'

export function QuotePortal({ index, ...props }: PortalProps) {
  // We might need to offset the index if we want to skip the first ticker (eg. static image chart)
  const context = React.useContext(QuoteContext)
  const elementIndex = index ?? context.index

  return <Portal index={elementIndex} {...props} />
}
